<template>
	<div class="feedback" id="feedback" @paste="_handlePaste">
		<div class="feedback__widget">
			<transition name="wf__feedback_minimized">
				<template v-if="welcome_text && opened === false">
					<div class="feedback__minimized">
						<div class="feedback__minimized_label" data-test-id="arm-feedback" @click="_handleClickOpen">
							<span class="feedback__minimized_label--text"><span class="w-inline" v-html="welcome_text"></span></span>
							<svg
								data-no-dragscroll=""
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								class="w-icon w-icon_size_16"
								style="margin-top: 5px"
							>
								<path
									data-no-dragscroll=""
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M4.09688 10.9056L6.14251 10.5468L12.6594 4.02907L10.973 2.34141L4.45569 8.85948L4.09688 10.9056ZM13.9522 3.90804L11.0952 1.049C11.0299 0.983668 10.9164 0.983668 10.8511 1.049L3.56426 8.33672C3.53847 8.36251 3.523 8.39345 3.51613 8.42784L3.00902 11.3195C2.93848 11.7081 3.2928 12.052 3.68287 11.9935L6.57423 11.4863C6.60861 11.4794 6.64127 11.464 6.66534 11.4382L13.9522 4.15045C14.0159 4.08683 14.0159 3.97166 13.9522 3.90804ZM2.5 15C2.22386 15 2 14.7761 2 14.5C2 14.2239 2.22386 14 2.5 14H13.5C13.7761 14 14 14.2239 14 14.5C14 14.7761 13.7761 15 13.5 15H2.5Z"
									fill="#999"
								/>
							</svg>
						</div>
					</div>
				</template>
			</transition>
			<transition name="wf__feedback_opened">
				<template v-if="opened === true">
					<div class="feedback__opened">
						<a href="javascript:void(0)" class="feedback__close" @click="_handleClickClose">
							<svg class="w-icon w-icon_size_22" viewBox="0 0 32 32" fill="#FFF" style="margin-top: 6px">
								<path
									d="M14.117 16.001l-12.782 12.784 1.884 1.882 12.781-12.783 12.781 12.783 1.884-1.882-12.782-12.784 12.784-12.786-1.884-1.882-12.783 12.785-12.783-12.785-1.884 1.882 12.784 12.786z"
								></path>
							</svg>
						</a>
						<div class="feedback__content">
							<div class="feedback__content_comment">
								<textarea
									data-test-id="feedback_comment"
									name="feedback__comment"
									id="feedback__comment"
									ref="feedback__comment"
									rows="3"
									:placeholder="placeholder_text"
									v-model="comment"
									:class="{ 'is-invalid': !!errors }"
								>
								</textarea>

								<div class="feedback__actions">
									<div class="w-row">
										<template v-if="images.loading === false">
											<div
												data-test-id="screenshot"
												class="feedback__action_screenshot mr_4"
												@click="_handleClickCreateScreenshot"
												v-tooltip="{ content: 'Добавить скриншот (Alt+P)', classes: 'feedback-tooltip' }"
											>
												<svg
													class="w-icon w-icon_size_22"
													viewBox="0 0 512 512"
													style="opacity: 0.8; margin-right: 10px"
												>
													<g>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M60,150.5c0,11.046,8.954,20,20,20s20-8.954,20-20v-50h49c11.046,0,20-8.954,20-20s-8.954-20-20-20h-49v-40 c0-11.046-8.954-20-20-20s-20,8.954-20,20v40H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h40V150.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M432,210.5c-11.046,0-20,8.954-20,20v52c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-52 C452,219.454,443.046,210.5,432,210.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M362,100.5h10c22.056,0,40,17.944,40,40v10c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-10 c0-44.112-35.888-80-80-80h-10c-11.046,0-20,8.954-20,20S350.954,100.5,362,100.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M80,210.5c-11.046,0-20,8.954-20,20v52c0,11.046,8.954,20,20,20s20-8.954,20-20v-52C100,219.454,91.046,210.5,80,210.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M150,411.5h-10c-22.056,0-40-17.944-40-40v-9c0-11.046-8.954-20-20-20s-20,8.954-20,20v9c0,44.112,35.888,80,80,80h10 c11.046,0,20-8.954,20-20C170,420.454,161.046,411.5,150,411.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M492,411.5h-40v-49c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v49h-50c-11.046,0-20,8.954-20,20 c0,11.046,8.954,20,20,20h50v40c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-40h40c11.046,0,20-8.954,20-20 C512,420.454,503.046,411.5,492,411.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M282,60.5h-52c-11.046,0-20,8.954-20,20s8.954,20,20,20h52c11.046,0,20-8.954,20-20S293.046,60.5,282,60.5z"
														/>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M282,411.5h-52c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h52c11.046,0,20-8.954,20-20 C302,420.454,293.046,411.5,282,411.5z"
														/>
													</g>
												</svg>
											</div>
											<div class="feedback__action_screenshot">
												<label
													class="cursor-pointer"
													for="upload_screenshot"
													v-tooltip="{ content: 'Загрузить скриншот', classes: 'feedback-tooltip' }"
												>
													<svg
														class="w-icon w-icon_size_22"
														width="16"
														height="16"
														viewBox="0 0 16 16"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M9.81491 2.57776C10.5554 1.80064 11.756 1.80064 12.4965 2.57776C13.2371 3.35489 13.2371 4.61479 12.4965 5.39191L6.79803 11.3719C6.42779 11.7605 5.82747 11.7605 5.45723 11.3719C5.08699 10.9834 5.08699 10.3534 5.45723 9.9649L9.49584 5.72675C9.67449 5.53927 9.67448 5.24456 9.49582 5.05709C9.30456 4.8564 8.98435 4.8564 8.7931 5.0571L4.78677 9.26138C4.04629 10.0384 4.04629 11.2984 4.78677 12.0755C5.52725 12.8526 6.72789 12.8526 7.46848 12.0755L13.167 6.09543C14.2777 4.92978 14.2777 3.0399 13.167 1.87424C12.0561 0.708586 10.2553 0.708586 9.14445 1.87424C7.12435 3.99416 5.12451 6.09286 3.1108 8.20606C1.62973 9.76025 1.62973 12.2801 3.1108 13.8344C4.59176 15.3885 6.99304 15.3885 8.47411 13.8344L12.8479 9.24442C13.0265 9.05694 13.0265 8.76223 12.8479 8.57476C12.6566 8.37407 12.3364 8.37408 12.1452 8.57478L7.80365 13.1308C6.69282 14.2965 4.89198 14.2965 3.78114 13.1308C2.67043 11.9651 2.67043 10.0752 3.78114 8.90958L9.81491 2.57776Z"
														/>
													</svg>
													<input
														id="upload_screenshot"
														type="file"
														accept="image/*"
														@change="_handleChangeUploadScreenshot"
														class="d-none"
													/>
												</label>
											</div>
										</template>
										<template v-if="images.loading === true">
											<div class="screenshot-loading-ripple">
												<div></div>
												<div></div>
											</div>
										</template>
									</div>
								</div>

								<div class="feedback__screenshots">
									<div
										data-test-id="screenshot_item"
										class="feedback__screenshot_item"
										v-for="img in images['data']"
										:key="img.src"
									>
										<div rel="noopener">
											<div
												class="feedback__screenshot_item--remove"
												@click.stop.prevent="_handleClickRemoveScreenshot(img.uid)"
											>
												<svg
													class="w-icon"
													viewBox="0 0 32 32"
													fill="#FFF"
													style="width: 7px; height: 7px; margin-top: 0.25em"
												>
													<path
														d="M14.117 16.001l-12.782 12.784 1.884 1.882 12.781-12.783 12.781 12.783 1.884-1.882-12.782-12.784 12.784-12.786-1.884-1.882-12.783 12.785-12.783-12.785-1.884 1.882 12.784 12.786z"
													></path>
												</svg>
											</div>
											<img
												:src="img.src"
												:alt="img.alt"
												v-tooltip="{ content: img.alt, classes: 'feedback-tooltip' }"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="feedback__footer">
							<div class="w-row">
								<div class="w-column feedback__footer_description">
									<span v-if="cheers_text">
										<span class="w-inline" v-html="cheers_text"></span>
										<svg class="w-icon w-icon_size_22" viewBox="0 0 47 47" style="opacity: 0.8; margin-right: 10px">
											<g>
												<path
													d="M29.062,9.086c0-4.797,3.904-8.701,8.703-8.701c4.797,0,8.701,3.903,8.701,8.701c0,1.381-1.119,2.5-2.5,2.5 s-2.5-1.119-2.5-2.5c0-2.041-1.66-3.701-3.701-3.701c-2.042,0-3.703,1.66-3.703,3.701c0,1.381-1.119,2.5-2.5,2.5 S29.062,10.466,29.062,9.086z M1.339,9.059c0-4.797,3.904-8.701,8.703-8.701c4.797,0,8.701,3.903,8.701,8.701 c0,1.381-1.119,2.5-2.5,2.5c-1.381,0-2.5-1.119-2.5-2.5c0-2.041-1.66-3.701-3.701-3.701c-2.042,0-3.703,1.66-3.703,3.701 c0,1.381-1.119,2.5-2.5,2.5S1.339,10.44,1.339,9.059z M0.23,31.41c-0.636-1.53,0.089-3.286,1.62-3.921 c0.376-0.156,0.766-0.23,1.15-0.23c1.176,0,2.292,0.696,2.771,1.851c2.777,6.685,9.655,11.004,17.523,11.004 c7.69,0,14.528-4.321,17.421-11.011c0.658-1.521,2.424-2.223,3.943-1.563c1.521,0.658,2.221,2.423,1.563,3.944 C42.38,40.37,33.38,46.112,23.294,46.112C12.993,46.113,3.94,40.342,0.23,31.41z"
												/>
											</g>
										</svg>
									</span>
								</div>
								<div class="w-column w_auto">
									<button
										data-test-id="feedback_submit"
										class="w-btn w-btn_secondary w-btn_small"
										@click="_handleClickCreateIssue"
										:disabled="loading || isEmpty"
										v-tooltip="{ content: 'Отправить (Ctrl+Enter)', classes: 'feedback-tooltip' }"
									>
										Отправить
									</button>
								</div>
							</div>
						</div>
					</div>
				</template>
			</transition>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import urlUtil from '@uarmSrc/util-url.js';
import dateUtil from '@uarmSrc/util-date.js';
import { generateUUID } from '@uarmSrc/utils.js';
import html2canvas from 'html2canvas';
import { VTooltip } from 'v-tooltip';

export default {
	name: 'InexFeedback',
	props: {
		siteId: {
			type: Number,
		},
		recordId: {
			type: Number,
		},
		armMeta: {
			type: Object,
		},
	},
	directives: { tooltip: VTooltip },
	data() {
		return {
			opened: false,
			images: {
				data: [],
				loading: false,
			},
			comment: null,
			loading: false,
			errors: false,
			msgs: null,
			welcome_text: '',
			placeholder_text: '',
			cheers_text: '',
			email: '',
			fio: '',
		};
	},
	mounted() {
		on(this.$el, 'keydown', this._handleKeyUp);

		let vm = this;
		// ИФР сообщения для плашки, подсказки в поле сообщения и текста рядом с кнопкой
		let feedbackPage = urlUtil.getDomain() + '/ru/page/21090';
		axios
			.get(feedbackPage)
			.then((res) => {
				vm.msgs = Object.assign({}, res.data?.PARAMS?.IFR_MESSAGE_MAIN);
			})
			.catch((error) => {
				console.log('InexFeedback:', error);
				vm.msgs = [
					{
						IFR_MESSAGE_LOCALE__ID: {
							TEXT: '<p>Направить пожелание</p>',
						},
						NAME: 'CMS_FEEDBACK_BTN_OPEN',
					},
					{
						IFR_MESSAGE_LOCALE__ID: {
							TEXT: '<p>Опишите ваше предложение</p>',
						},
						NAME: 'CMS_FEEDBACK_PLACEHOLDER',
					},
					{
						IFR_MESSAGE_LOCALE__ID: {
							TEXT: '<p>Рассмотрим все пожелания</p>',
						},
						NAME: 'CMS_FEEDBACK_CHEER',
					},
				];
			});

		let urlProfile = urlUtil.getDomain() + '/auth/user/profile';
		axios.get(urlProfile).then((res) => {
			vm.email = res.data.mail;
			vm.fio = [res.data.lastName, res.data.firstName, res.data.middleName].join(' ');
		});
	},
	beforeDestroy() {
		off(this.$el, 'keydown', this._handleKeyUp);
	},
	watch: {
		msgs() {
			for (let indx in this.msgs) {
				switch (this.msgs[indx]?.NAME) {
					case 'CMS_FEEDBACK_BTN_OPEN':
						this.welcome_text = this.msgs[indx].IFR_MESSAGE_LOCALE__ID.TEXT;
						break;
					case 'CMS_FEEDBACK_CHEER':
						this.cheers_text = this.msgs[indx].IFR_MESSAGE_LOCALE__ID.TEXT;
						break;
					case 'CMS_FEEDBACK_PLACEHOLDER':
						this.placeholder_text = this.msgs[indx].IFR_MESSAGE_LOCALE__ID.TEXT.replace('<p>', '').replace('</p>', '');
						break;
				}
			}
		},
		opened(val) {
			if (val && !this.images.data.length && !this.images.loading) {
				this._handleClickCreateScreenshot();
			}
		},
	},
	computed: {
		cvpm_id() {
			return this.siteId;
		},
		cvpm_name() {
			let adminName =
				document.getElementsByClassName('admin_header__item-name')[0]?.innerText ||
				document.getElementsByClassName('AdminToolBar')[0]?.innerText.split('|')[0].trim() ||
				null;
			return window.navigator.userAgent?.indexOf('metawizard') != -1 ? 'Wizard' : adminName;
		},
		arm_id() {
			return this.armMeta.id;
		},
		card_id() {
			return this.recordId || null;
		},
		name() {
			return this.armMeta.caption;
		},
		url() {
			return window.location.href;
		},
		text() {
			return this.comment;
		},
		browser_data() {
			return window.navigator.userAgent;
		},
		window_size() {
			return 'ШхВ: ' + window.innerWidth + 'x' + window.innerHeight + ', ориентация: ' + window.screen.orientation.type;
		},
		mobile() {
			return window.navigator.userAgentData?.mobile;
		},
		isEmpty() {
			return !this.comment || /^\s*$/.test(this.comment) === true;
		},
	},
	methods: {
		_handleKeyUp(e) {
			// console.log('key code', e);

			if ((e.ctrlKey || e.metaKey) && (e.keyCode === 13 || e.keyCode === 10)) {
				this._handleClickCreateIssue();
			}

			if (e.altKey && e.keyCode === 80) {
				this._handleClickCreateScreenshot();
				e.preventDefault();
			}

			if (e.keyCode === 27) {
				this._handleClickClose();
			}
		},
		_handleClickOpen() {
			this.opened = true;

			this.$nextTick(() => {
				if (this.$refs.feedback__comment) {
					this.$refs.feedback__comment.focus();
				}
			});
		},
		_handleClickClose() {
			this.opened = false;
		},
		_handlePaste(e) {
			if (e.clipboardData && e.clipboardData.getData) {
				let pastedData = e.clipboardData.items[0];
				if (pastedData.type.indexOf('image') === 0) {
					e.preventDefault();
					const image = pastedData.getAsFile();

					this.createImage(image);
				}
			}
		},
		createImage(file) {
			if (typeof FileReader === 'function') {
				this.images.loading = true;

				let reader = new FileReader();
				const { name: fileName } = file;

				let item = {
					file,
					src: null,
					alt: fileName,
					uid: generateUUID(),
				};

				reader.onload = (el) => {
					item.src = el.target.result;

					this.images.loading = false;
					this.images.data.unshift(item);

					reader.onerror = (error) => console.log(error);
				};

				reader.readAsDataURL(file);
			} else console.log('Sorry, FileReader API not supported');
		},
		_handleClickCreateScreenshot() {
			this.images.loading = true;

			const options = {
				useCORS: true,
				imageTimeout: 0,
				allowTaint: true,
				ignoreElements: (element) => {
					if ('feedback' == element.id) {
						return true;
					}
				},
			};

			setTimeout(() => {
				html2canvas(document.body, options).then((canvas) => {
					canvas.toBlob(
						(blob) => {
							this.images.loading = false;

							const today = dateUtil.dateObjToHumanDate(dateUtil.getCurrentDate());
							const number = this.images.data.length + 1;
							const fileName = `Скриншот [${number}] ${today}`;

							// const fileName = `Скриншот ${format(new Date(), 'dd.MM.yyyy mm:ss')}`;

							this.images.data.unshift({
								uid: generateUUID(),
								src: URL.createObjectURL(blob),
								file: new File([blob], fileName, { type: 'image/jpeg' }),
								alt: fileName,
							});
						},
						'image/jpeg',
						1,
					);
				});
			}, 500);

			/*
				const options = {
					filter: function (element) {
						return element.id !== 'feedback'
					}
				};

				domtoimage.toBlob(document.body, options).then((blob) => {
					this.images.loading = false;

					const fileName = `Скриншот ${format(new Date(), 'dd.MM.yyyy mm:ss')}`;

					this.images.data.unshift({
						uid: generateUUID(),
						src: URL.createObjectURL(blob),
						file: new File([blob], fileName, { type: "image/jpeg" }),
						alt: fileName
					})
				}).catch((error) => {
					console.error('oops, something went wrong!', error);
				})
				*/
		},
		_handleClickRemoveScreenshot(uid) {
			const index = this.images.data.findIndex((i) => i.uid === uid);
			if (index > -1) {
				this.images.data.splice(index, 1);
			}
		},
		_handleChangeUploadScreenshot(el) {
			let files = el.target.files || el.dataTransfer.files;

			if (!files.length) {
				return false;
			}

			const file = el.target.files[0];

			if (!file.type.includes('image/')) {
				console.log('Please select an image file');
				return false;
			}

			this.createImage(file);
		},
		_handleClickCreateIssue() {
			this._createIssue()
				.then((res) => {
					// console.log(res, 'Спасибо. Информация отправлена разработчикам.');
					this.$notify({ type: 'success', text: 'Спасибо. Информация отправлена разработчикам.' });
					this._clearModal().then(() => {
						this._handleClickClose();
					});
				})
				.catch((err) => {
					// console.log(err, 'Не удалось отправить информацию');
					this.$notify({ type: 'error', text: 'Не удалось отправить информацию' });
				});
		},
		_createIssue() {
			let vm = this;
			return new Promise((resolve, reject) => {
				vm.loading = true;

				let submitArg = vm.getFormdataArg();
				let feedbackObj = {
					records: [],
				};
				feedbackObj.records.push(submitArg);

				let armId = vm.images.data ? 'multi' : submitArg.armId;
				let apiUrl = urlUtil.getDomain() + urlUtil.getPath() + vm.cvpm_id + '/' + armId + '/data';

				var fData = new FormData();

				vm.images.data.forEach((image, k) => {
					let formFieldName = 'file-' + k + '-' + Math.floor(Math.random() * 1e5);

					if (k === 0) {
						feedbackObj.records[0].fields.push({ fieldId: 'data_id', value: { formField: formFieldName } });
					}
					let fileObj = {
						mode: 'create',
						armId: 21093,
						fields: [
							{ fieldId: 'cms_feedback_id', linkedValue: { recordIndex: 0, fieldId: 'id' } },
							{ fieldId: 'data_id', value: { formField: formFieldName } },
						],
					};
					feedbackObj.records.push(fileObj);
					fData.append(formFieldName, image.file);
					// console.log('file', formFieldName, image.file);
				});

				fData.append('jsonPayload', JSON.stringify(feedbackObj));
				// console.log('send to ARM ', feedbackObj);

				axios
					.post(apiUrl, fData)
					.then((res) => {
						let isOk = res.data && res.data.records && res.data.records.length !== 0;
						if (isOk) {
							vm.$notify({
								type: 'success',
								text: 'Мы всё записали, спасибо.',
							});
							// console.log('Success!');
							vm._clearModal().then(() => {
								vm._handleClickClose();
							});
						} else {
							// console.log(res);
							throw Error('Ошибка сабмита');
						}
					})
					.catch(function (thrown) {
						console.log(thrown);
					})
					.then(function () {
						vm.loading = false;
					});
			});
		},
		getFormdataArg: function () {
			var vm = this;
			let result = {
				armId: 21090,
				mode: 'create',
				fields: [],
			};
			let params = {
				cvpm_name: vm.cvpm_name,
				arm_id: vm.arm_id,
				name: vm.name,
				url: vm.url,
				text: vm.text,
				browser_data: vm.browser_data,
				window_size: vm.window_size,
				mobile: vm.mobile,
				user_name: vm.fio,
				user_email: vm.email || '',
			};
			if (this.card_id) {
				params.card_id = this.card_id;
			}
			for (let p in params) {
				let param = { fieldId: p, value: params[p] };
				result.fields.push(param);
			}
			return result;
		},
		_clearModal() {
			return new Promise((resolve, reject) => {
				try {
					this.comment = null;
					this.images = {
						data: [],
						loading: false,
					};
					resolve && resolve();
				} catch (e) {
					reject && reject();
				}
			});
		},
	},
};
const on = function (element, event, handler) {
	if (typeof document !== 'undefined') {
		if (element && event && handler) {
			element._eventListener = handler;
			element.addEventListener(event, handler, false);
		}
	}
};
const off = function (element, event, handler) {
	if (typeof document !== 'undefined') {
		if (element && event) {
			if (!handler && element._eventListener) {
				handler = element._eventListener;
				element._eventListener = undefined;
			}
			element.removeEventListener(event, handler, false);
		}
	}
};
</script>
